export default [
  {
    path: '/domainManage/singleDomain/domainConfig',
    meta: {
      title: '域名配置',
      leftMenuCode: 'StaticDomainManagement',
      backable: true,
      showDomainHeader: true
    },
    component: () => import('@/views/domainManage/singleDomain/domainConfig.vue')
  },
  {
    path: '/domainManage/singleDomain/accelerationConfig',
    meta: {
      title: '加速配置',
      leftMenuCode: 'StaticDomainManagement',
      backable: true,
      showDomainHeader: true
    },
    component: () => import('@/views/domainManage/singleDomain/accelerationConfig.vue')
  }
]